import styled, { css, DefaultTheme } from 'styled-components';

const variantStyles = (theme: DefaultTheme, variant = 'warning') =>
  ({
    success: css`
      background-color: ${theme.palette.lightSuccess};

      .alert__icon {
        color: ${theme.palette.darkSuccess};
      }
    `,
    error: css`
      background-color: ${theme.palette.LightCoral};

      .alert__icon {
        color: ${theme.palette.tomato};
      }
    `,
    info: css`
      background-color: ${theme.palette.lightClearBlue};

      .alert__icon {
        color: ${theme.palette.blue};
      }
    `,
    warning: css`
      background-color: ${theme.palette.wheat};

      .alert__icon {
        color: ${theme.palette.peru};
      }
    `,
  }[variant]);

export const AlertWrapper = styled.div<{ variant?: string }>`
  display: flex;
  align-items: baseline;
  column-gap: 7.5px;
  padding: 15px;
  margin-top: 5px;

  ${({ theme, variant }) => variantStyles(theme, variant)}

  h6 {
    font-size: 16px;
    color: ${({ theme }) => theme.palette.black11};
    margin-bottom: 0px;
  }

  p {
    font-size: 13px;
    margin-bottom: 0px;
  }

  .alert__body {
    display: flex;
    flex-direction: column;
  }
`;
